import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { Badge, Breadcrumbs, SkeletonBase } from "@unified-checkout/design-system";
import { formatToLocalizedDateTime } from "libs/design-system/src/utils/dateFormats";

import { INNER_ROUTES } from "@app/dashboard/constants/inner-routes";
import type { TDisputeStatus } from "@app/dashboard/types/innerLayout/disputes";
import { useLangStore } from "@app/dashboard/store/lang";
import { statusBadgePropsMap } from "../../../utils";
import styles from "./header.module.scss";


export const Header = ({
  disputeId,
  status,
  statusLabel,
  createdAt,
  isLoading
}: {
  disputeId?: string | number,
  status?: TDisputeStatus,
  statusLabel?: string,
  createdAt?: string,
  isLoading: boolean
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { lang } = useLangStore();

  return (
    <div className={styles["header"]}>

      {
        isLoading ?
          <SkeletonBase width="11rem" height="1.5rem" />
          :
          <div className={styles["header__breadcrumbs"]}>
            <Breadcrumbs
              linksProps={[
                {
                  text: t('innerLayout.disputesPage.disputeDetails.header.breadcrumbs.disputes'),
                  active: true,
                  onClickHandler: () => navigate(INNER_ROUTES.DISPUTES)
                },
                {
                  text: t('innerLayout.disputesPage.disputeDetails.header.breadcrumbs.disputeId', { id: disputeId })
                }
              ]}
            />
          </div>
      }

      <div className={styles["header__info-box"]}>

        <div className={styles["header__info-box__title-box"]}>

          {
            isLoading ?
              <SkeletonBase width="11.8rem" height="2rem" />
              :
              <div className={styles["header__info-box__title-box__title"]}>
                {t('innerLayout.disputesPage.disputeDetails.title')}
              </div>
          }
          {
            isLoading ?
              <SkeletonBase width="12.8rem" height="1.5rem" />
              :
              <div className={styles["header__info-box__title-box__hint"]}>
                {
                  t('innerLayout.disputesPage.disputeDetails.header.createdAt').replace(
                    '{{date}}',
                    formatToLocalizedDateTime(createdAt as string, lang)
                  )
                }
              </div>
          }
        </div>

        {
          isLoading ?
            <SkeletonBase width="10rem" height="2rem" />
            :
            <Badge
              size="lg"
              text={statusLabel}
              color={statusBadgePropsMap[status as TDisputeStatus]?.color || 'gray'}
            />
        }
      </div>

    </div>
  )
}
